import { acuityRequestsTyped } from "@/api/(requests)/acuityTyped";
import type { AcuityScore, PostAcuityScoreResponse, UUID } from "@/core/types";

export type PostAcuityScoreVariables = {
  additional_details?: string;
  patientId: UUID;
  reasoning: string;
  score: AcuityScore;
};

export async function postAcuityScore({
  additional_details,
  patientId,
  reasoning,
  score,
}: PostAcuityScoreVariables): Promise<PostAcuityScoreResponse> {
  return acuityRequestsTyped.post_acuity_score({
    context: { showLoader: false },
    data: { additional_details, reasoning, score },
    patientId,
  });
}
